"use client"

import React, {useEffect, useState} from 'react';
import styles from "./Segments.module.css";

import {pathSegmentsRequest} from "@/utils/api/Segments";
import SingleSegment from "@/components/Segments/SingleSegment/SingleSegment";
import {Segments as SegmentsType} from "@/types/Segments";
import Preload from "@/components/Segments/Preload";

export default function Segments(props: { id: string }) {
  const [data, setData] = useState<SegmentsType | undefined>(undefined)

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await pathSegmentsRequest(props.id)
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data) {
      fetchData()
    }
  }, [data, props.id]);

  return (
    <div className={styles.container}>
      {!data && <Preload/>}
      {data && data.items.map((item) => {
        return <SingleSegment data={item} key={item.id}/>
      })}
    </div>
  )
}
